import Vue from 'vue';
import AlarmTip from './alarmTip.vue';

import { makeMap, formatTimestamp, genComponentVNode } from '@/utils/utils';
import { i18n } from '@/locale';

/**
 * 右下角通知
 * @param {*} data 对应AlarmTip组件props
 */
export const notice = function (type, data) {
  const hasKey = makeMap('ALARM,DETECT');
  if (hasKey(type)) {
    data = fromSocketDataToAlarmTipProp(type, data);

    const body = genComponentVNode(AlarmTip, {
      ...data,
      callback() {
        instance.close();
      }
    });

    const _this = this instanceof Vue ? this : Vue.prototype;

    const instance = _this.$notify(
      noticeOptionMixin(type, {
        message: body
      })
    );

    return instance;
  }
};

/**
 * 警告|检测 消息的选项
 * @param {String} type alarm | check
 * @param {*} mixinOption 混入选项
 * @returns option
 */
function noticeOptionMixin(type, mixinOption) {
  const common = {
    dangerouslyUseHTMLString: true,
    customClass: 'notify-content-left',
    position: 'bottom-right',
    duration: 0
  };
  const op = {
    ALARM: {
      title: i18n.t('警告消息'),
      type: 'warning',
      customClass: 'alarm-notice'
    },
    DETECT: {
      title: i18n.t('检测消息'),
      iconClass: 'el-icon-detect'
    }
  };
  return Object.assign(common, op[type], mixinOption);
}

function fromSocketDataToAlarmTipProp(type, res) {
  if (type === 'ALARM') {
    const { beginTime, officeName, deviceType, deviceName, sn, message } = res.eventData;
    const alarmTime = formatTimestamp(beginTime);
    return { officeName, deviceType, deviceName, sn, message, alarmTime, type };
  } else if (type === 'DETECT') {
    let {
      endTimeD: alarmTime,
      officeName,
      deviceType,
      name: deviceName,
      sn,
      modState,
      message
    } = res;
    message =
      message ||
      Object.keys(modState)
        .map(e => `${modState[e].alarmContent}`)
        .join(',');
    return { alarmTime, officeName, deviceType, deviceName, sn, message, type };
  }
}
